<ng-container *ngIf="(view$ | async) as view; else loadingView">
  <ng-container *ngIf="(tableMetaWithConfig$ | async) as tableMeta; else loadingView">
    <ng-container *ngIf="(tableData$ | async) as tableData; else loadingView">

      <p-card>
        <ng-template pTemplate="header">
          <div class="pt-3 pl-3 pr-3 flex flex-column">
            <div class="ui-paginator list-counter md:flex">
              <h3>Rezultati pretrage</h3><app-odabir-pretrage class="ml-auto"></app-odabir-pretrage>
            </div>
            <!-- gumbići -->
            <div class="flex flex-column-reverse md:flex-row">
              <div class="flex align-items-center">
                <p-button class="m-1" icon="pi pi-table" (click)="changeLayout($event, 'table')"
                  (keydown.enter)="changeLayout($event, 'table')"></p-button>
                <p-button class="m-1" icon="pi pi-list" (click)="changeLayout($event, 'list')"
                  (keydown.enter)="changeLayout($event, 'list')"></p-button>
                <p-button class="m-1" icon="pi pi-th-large" (click)="changeLayout($event, 'grid')"
                  (keydown.enter)="changeLayout($event, 'grid')"></p-button>
                <div *ngIf="(selectedItems$ | async) as selection" class="selection-info-container pl-3">
                  <ntap-primeng-selection-info-bar [selectAllMode]="selectAllMode"
                    [selectAllChecked]="selectAllCheckbox" [totalRecords]="tableData.totalRecords"
                    [selectionLength]="selection.length"></ntap-primeng-selection-info-bar>
                </div>
              </div>
              <div class="ml-auto">
                <ntap-dynamic [compId]="tableToolbarCompId"></ntap-dynamic>
              </div>

            </div>
            <ng-container *ngIf="selectedItems.length > 0 && selectedLayoutOption.value !== 'table'">
              <div class="flex flex-column-reverse md:flex-row">
                <button pButton type="button" label="Odznači" icon="pi pi-times"
                  (click)="setSelectedItems([])"></button>
              </div>
            </ng-container>
          </div>

        </ng-template>

        <ng-container *ngIf="selectedLayoutOption.value === 'table'">
          <p-table #dataTable preventSelectionSetterPropagation="false" [value]="tableData.items" [dataKey]="dataKey"
            [columns]="tableMeta.columns" [selection]="selectedItems$ | async"
            (selectionChange)="setSelectedItems($event)" [selectionPageOnly]="true" [paginator]="true"
            responsiveLayout="stack" [loading]="(loadingState$ | async) ?? true" [lazy]="tableMeta.pagingSetup.lazy"
            [totalRecords]="tableData.totalRecords" (onPage)="tableMeta.pagingSetup.pageHandler($event, tableData)"
            (onSort)="tableMeta.pagingSetup.sortHandler($event)" [filters]="tableData.filters" [rows]="tableData.rows"
            [rowsPerPageOptions]="[15, 25, 50, 100]" [first]="tableData.firstIndex" paginatorPosition="bottom"
            [showJumpToPageInput]="true">

            <ng-template pTemplate="paginatorleft" let-state>
              {{ (state.totalRecords > 0) ? (state.first + 1) : state.first }} -
              {{ (state.first + state.rows > state.totalRecords) ? state.totalRecords : state.first + state.rows }}
              od {{ state.totalRecords }}
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngIf="tableMeta.selectionMode !== ''" class="table-col-checkbox"></th>
                <th *ngFor="let column of columns" [pSortableColumn]="column.name"
                  [pSortableColumnDisabled]="!column.sortable && view.sortable_columns.length > 0">
                  <!-- Prikazujemo ikonu zaključane kolone ako je zaključana -->
                  <ng-container *ngIf="isLockedColumn(column.name); else checkPublic">
                    <i class="pi pi-key" pTooltip="{{  column.description  }}"
                      style="font-size: 1.5rem; color: var(--yellow-600)"></i>
                  </ng-container>

                  <!-- Ako kolona nije zaključana, proveravamo da li je javna -->
                  <ng-template #checkPublic>
                    <ng-container *ngIf="isPublicColumn(column.name); else defaultColumn">
                      <i class="pi pi-eye" pTooltip="{{  column.description  }}"
                        style="font-size: 1.5rem; color: var(--blue-500)"></i>
                    </ng-container>
                  </ng-template>

                  <!-- Ako kolona nije ni zaključana ni javna, provjeravamo status -->
                  <ng-template #defaultColumn>
                    <ng-container *ngIf="isStatusColumn(column.name)"></ng-container>
                    <ng-container *ngIf="!isStatusColumn(column.name) "> {{ column.description }}</ng-container>
                  </ng-template>

                  <p-sortIcon
                    *ngIf="column.sortable || (view.sortable_columns.length === 0 && column.dataType !== 'boolean')"
                    [field]="column.name" ariaLabel="true"></p-sortIcon>
                </th>
                <th *ngIf="tableMeta.hasActions" class="table-col-actions"></th>
              </tr>
              <tr>
                <th *ngIf="tableMeta.selectionMode !== ''" class="table-col-checkbox">
                  <ng-container *ngIf="tableData.totalRecords > 0">
                    <p-overlayPanel #op>
                      <p-radioButton name="option1" inputId="option1" value="PAGE" [ngModel]="selectAllMode"
                        (ngModelChange)="selectedAllModeChanged($event)">
                      </p-radioButton>
                      <label for="option1" class="ml-2">Odaberi sve na stranici</label>
                      <p-radioButton class="ml-2" name="option2" inputId="option2" value="ALL" [ngModel]="selectAllMode"
                        (ngModelChange)="selectedAllModeChanged($event)">
                      </p-radioButton>
                      <label for="option2" class="ml-2">Odaberi sve rezultate</label>
                    </p-overlayPanel>
                    <p-tableHeaderCheckbox
                      (click)="op.toggle($event);toggleHeaderCheckbox($event)"></p-tableHeaderCheckbox>
                  </ng-container>
                </th>
                <th *ngFor="let column of columns">
                  <ng-container *ngIf="isStatusColumn(column.name)">
                  </ng-container>
                  <ng-container *ngIf="!isStatusColumn(column.name) ">
                    <ntap-prime-table-search [tableMeta]="tableMeta" [column]="column"></ntap-prime-table-search>
                  </ng-container>
                </th>
                <th ntapDebug></th>
                <th *ngIf="tableMeta.hasActions" class="table-col-actions"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" ngFor let-item let-rowIndex="rowIndex">
              <ng-container ntapListItemProvider #lid="ntapListItemProvider" [listIndex]="rowIndex" [item]="item"
                *ngIf="tableData.tableItems[tableMeta.pagingSetup.rowIndexFunction(tableData.firstIndex, rowIndex)] as tableItem">
                <tr>
                  <td *ngIf="tableMeta.selectionMode !== ''" class="table-data-no-overflow table-col-checkbox">
                    <span class="ui-cell-content">
                      <p-tableCheckbox *ngIf="tableMeta.selectionMode === 'multiple'" [value]="item"></p-tableCheckbox>
                      <p-tableRadioButton *ngIf="tableMeta.selectionMode === 'single'"
                        [value]="item"></p-tableRadioButton>
                    </span>
                  </td>

                  <td *ngFor="let column of tableMeta.columns" (click)="toggleExpandedRow(tableData, item)"
                    [ngClass]="DISPLAY_TEXT_OVERFLOW ? (isRowExpanded(tableData, item) ? 'table-data-expanded' : 'table-data-overflow') : 'table-data-no-overflow'">

                    @let isOpenItem = $any(column)["isOpenItemColumn"];

                    <div *ngIf="column.controlType === 14 else plainTextFormat">
                      <span class="ui-cell-content"><a href="{{ item[column.name] }}">{{
                          item[column.name] | displayFormat:column }}</a></span>
                    </div>

                    <ng-template #plainTextFormat>

                    @if (isOpenItem) {
                      <a class="ui-cell-content" href="#" (click)="openItem($event, lid)"><b>{{
                          $any(tableItem)[column.name] | displayFormat:column }}</b></a>
                    } @else {
                        <ng-container
                          *ngIf="!isLockedColumn(column.name) && !isPublicColumn(column.name) && !isStatusColumn(column.name)">
                          <!-- Prikaz kolone ako nije ni zaključana ni javna -->
                          <span class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat:column }}</span>
                        </ng-container>

                        <ng-container *ngIf="isLockedColumn(column.name)">
                          <!-- Prikaz za zaključanu kolonu -->
                          <i *ngIf="item[column.name]" class="pi pi-lock" pTooltip="Zaključano"
                            style="font-size: 1.5rem;color: var(--red-500);"></i>
                          <i *ngIf="!item[column.name]" class="pi pi-lock-open" pTooltip="Otključano"
                            style="font-size: 1.5rem;color: var(--blue-500);"></i>
                        </ng-container>

                        <ng-container *ngIf="isPublicColumn(column.name)">
                          <!-- Prikaz za javnu kolonu -->
                          <i *ngIf="item[column.name]" class="pi pi-eye" pTooltip="Objavljeno"
                            style="font-size: 1.5rem;color: var(--blue-500);"></i>
                          <i *ngIf="!item[column.name]" class="pi pi-eye-slash" pTooltip="Neobjavljeno"
                            style="font-size: 1.5rem;color: var(--red-500);"></i>
                        </ng-container>

                        <ng-container *ngIf="isStatusColumn(column.name)">
                          <i *ngIf="item[column.name] === 'VERIFICIRAN'" class="pi pi-verified"
                            pTooltip="{{  $any(tableItem)[column.name]  }}"
                            style="font-size: 1.5rem; color: var(--red-400)"></i>
                          <i *ngIf="item[column.name] === 'ZA_VERIFIKACIJU'" class="pi pi-circle"
                            pTooltip="{{  $any(tableItem)[column.name]  }}"
                            style="font-size: 1.5rem; color: var(--yellow-300)"></i>
                          <i *ngIf="item[column.name] === 'U_OBRADI'" class="pi pi-file-edit"
                            pTooltip="{{  $any(tableItem)[column.name]  }}" style="font-size: 1.5rem;"></i>
                          <i *ngIf="item[column.name] === 'NONE'" class="pi pi-question-circle"
                            pTooltip="{{  $any(tableItem)[column.name]  }}"
                            style="font-size: 1.5rem; color: var(--yellow-300)"></i>
                        </ng-container>
                  }
                    </ng-template>
                  </td>

                  <td *ngIf="tableMeta.hasActions" class="table-col-actions">
                    <span class="ui-cell-content">
                      <ntap-dynamic #rowActionBar [compId]="actionBarCompId"></ntap-dynamic>
                    </span>
                  </td>
                </tr>
              </ng-container>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="tableMeta.totalColumns" class="table-data-no-overflow">
                  Nema podataka.
                </td>
              </tr>
            </ng-template>

          </p-table>

        </ng-container>

        <ng-container *ngIf="selectedLayoutOption.value === 'grid' || selectedLayoutOption.value === 'list'">
          <ng-container *ngIf="selectedLayoutOption.value === 'list'">
            <p-table #dataTable (onSort)="tableMeta.pagingSetup.sortHandler($event)" [filters]="tableData.filters"
              [rows]="tableData.rows" [showJumpToPageInput]="true">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let column of tableMeta.columns" [pSortableColumn]="column.name">
                    {{ column.description }}
                    <p-sortIcon
                      *ngIf="column.sortable || (view.sortable_columns.length === 0 && column.dataType !== 'boolean')"
                      [field]="column.name" ariaLabel="true"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>

          <p-dataView #dv [value]="tableData.items" [paginator]="true" filterBy="name"
            [layout]="selectedLayoutOption.value" [loading]="(loadingState$ | async) ?? true"
            [lazy]="tableMeta.pagingSetup.lazy" [totalRecords]="tableData.totalRecords"
            (onPage)="tableMeta.pagingSetup.pageHandler($event, tableData)"
            (onSort)="tableMeta.pagingSetup.sortHandler($event)" [rows]="tableData.rows" [first]="tableData.firstIndex"
            [rowsPerPageOptions]="[15, 25, 50, 100]" paginatorPosition="bottom">
            <ng-template pTemplate="listItem" ngFor let-item let-items>
              <ng-container *ngFor="let item of items; let first = first; let rowIndex = index">
                <ng-container ntapListItemProvider #lid="ntapListItemProvider" [listIndex]="rowIndex" [item]="item"
                  *ngIf="tableData.tableItems[rowIndex] as tableItem">
                  <div class="col-12 flex pb-2 mb-2">
                    <div class="flex flex-column md:flex-row align-items-center w-full" (click)="selectItem(item)"
                      [class.selected]="isSelected(item)">
                      <img *ngIf="item['$hasContent']" [src]="createUrl(item)" (error)="errorImg($event.target)"
                        class="my-4 md:my-0 w-9 md:w-15rem shadow-2 mr-5" />
                      <span *ngIf="!item['$hasContent'] && selectedLayoutOption.value === 'grid'"
                        class="placeholder-image list my-4 md:my-0 w-9 md:w-15rem shadow-2 mr-5">Nema slike</span>
                      <div class="flex-1 flex flex-column align-items-left text-center md:text-left">
                        <!-- Vrsta agenta i identifikator -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.agentTypeColumn as agentTypeColumn">
                            <p *ngIf="$any(tableItem)[agentTypeColumn] as data"
                              class="mb-0 white-space-nowrap text-sm bg-primary text-white px-2 mr-2 mb-2">{{ data }}
                            </p>
                          </ng-container>
                          <ng-container *ngIf="tableMeta.identifierColumn as identifierColumn">
                            <i *ngIf="$any(tableItem)[identifierColumn] as data"
                              class="nullsafe font-semibold text-400 text-sm text-left pr-2 mb-2">{{ data }}</i>
                          </ng-container>
                        </div>

                        <!-- Naslov -->
                        <ng-container *ngIf="tableMeta.titleColumn as titleColumn">
                        @let isOpenItem = $any(tableMeta)["isTitleOpenItemColumn"];
                        @if (isOpenItem) {  
                            <div class="nullsafe font-bold text-2xl mb-2 flex align-items-center">
                              <a class="ui-cell-content" href="#"
                                (click)="openItem($event, lid); $event.stopPropagation();"><b>{{
                                  $any(tableItem)[titleColumn] }}</b></a>
                              <i *ngIf="item['en~jedinica_gradiva~locked']" class="pi pi-lock ml-2" pTooltip="Zaključano"
                                style="font-size: 1.2rem; color: var(--red-500);"></i>
                              <i *ngIf="item['en~jedinica_gradiva~locked'] === false" class="pi pi-lock-open ml-2" pTooltip="Otključano"
                                style="font-size: 1.2rem; color: var(--blue-500);"></i>
                            </div>
                        } @else {
                            <div class="nullsafe font-bold text-2xl mb-2 flex align-items-center">
                              {{ $any(tableItem)[titleColumn] }}
                              <i *ngIf="item['en~jedinica_gradiva~locked']" class="pi pi-lock ml-2" pTooltip="Zaključano"
                                style="font-size: 1.2rem; color: var(--red-500);"></i>
                              <i *ngIf="item['en~jedinica_gradiva~locked'] === false" class="pi pi-lock-open ml-2" pTooltip="Otključano"
                                style="font-size: 1.2rem; color: var(--blue-500);"></i>
                            </div>
                        }
                        </ng-container>

                        <!-- Arhivska oznaka -->
                        <div class="agent-type flex align-items-center">
                          <div class="flex">
                            <ng-container *ngIf="tableMeta.labelColumn as labelColumn">
                              <ng-container *ngIf="$any(tableItem)[labelColumn] as data">
                                <label class="nowraptext font-semibold align-self-start text-primary">Arhivska
                                  oznaka:</label>&nbsp;
                                <p class="white-space-nowrap text-sm bg-primary text-white px-2 mr-2 mb-2">{{ data }}
                                </p>
                              </ng-container>
                            </ng-container>
                          </div>
                          <!-- Oblik vlasništva -->
                          <div class="agent-type inline-flex align-items-right">
                            <ng-container *ngIf="tableMeta.ownerTypeColumn as ownerTypeColumn">
                              <ng-container *ngIf="$any(tableItem)[ownerTypeColumn] as data">
                                <p class="text-sm bg-primary text-white px-2 mr-2 mb-2">{{ data }}</p>
                              </ng-container>
                            </ng-container>
                          </div>
                        </div>

                        <!-- Sjedište -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.headquartersColumn as headquartersColumn">
                            <ng-container *ngIf="$any(tableItem)[headquartersColumn] as data">
                              <label
                                class="nowraptext font-semibold align-self-start text-primary">Sjedište:</label>&nbsp;
                              <p class="mb-0 white-space-nowrap text-base px-2 mr-2 mb-2">{{ data }}</p>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Radno vrijeme -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.hoursColumn as hoursColumn">
                            <ng-container *ngIf="$any(tableItem)[hoursColumn] as data">
                              <label class="nowraptext font-semibold align-self-start text-primary">Radno
                                vrijeme:</label>&nbsp;
                              <p class="mb-0 white-space-nowrap text-base px-2 mr-2 mb-2">{{ data }}</p>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Vrijeme nastanka -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.createdColumn as createdColumn">
                            <ng-container *ngIf="$any(tableItem)[createdColumn] as data">
                              <label class="nowraptext font-semibold align-self-start text-primary">Vrijeme
                                nastanka:</label>&nbsp;
                              <p class="white-space-nowrap text-sm bg-primary text-white px-2 mr-2 mb-2">{{ data }}</p>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Razina -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.levelColumn as levelColumn">
                            <label class="nowraptext font-semibold align-self-start text-primary">Razina:</label>&nbsp;
                            <p *ngIf="$any(tableItem)[levelColumn] as data"
                              class="mb-0 white-space-nowrap text-sm bg-primary text-white px-2 mr-2 mb-2">{{ data }}
                            </p>
                          </ng-container>
                        </div>

                        <!-- Posjednik / Nadlezni arhiv -->
                        <div class="agent-type flex align-items-center">
                          <ng-container
                            *ngIf="selectedLayoutOption.value === 'list' && tableMeta.ownerColumn as ownerColumn">
                            <ng-container *ngIf="$any(tableItem)[ownerColumn] as data">
                              <label
                                class="nowraptext font-semibold align-self-start text-primary">Posjednik:</label>&nbsp;
                              <p class="line-height-2 text-base">{{ data }}</p>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Nadređena jedinica gradiva -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.hierarhyLabelColumn as hierarhyLabelColumn">
                            <ng-container *ngIf="$any(tableItem)[hierarhyLabelColumn] as data">
                              <label class="nowraptext font-semibold align-self-start text-primary">Nalazi se
                                u:</label>&nbsp;
                              <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Sadržaj -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.contentColumn as contentColumn">
                            <ng-container *ngIf="$any(tableItem)[contentColumn] as data">
                              <p class="line-height-2 text-base">
                                <span [ngClass]="{ 'custom-truncated-text': !isRowExpanded(tableData, item) }">
                                  {{ data }}
                                </span>

                                <span *ngIf="shouldShowToggle(data) && !isRowExpanded(tableData, item)" class="prikazi"
                                  (click)="gridtoggleExpandedRow(tableData, item)">
                                  Prikaži više
                                </span>

                                <span *ngIf="isRowExpanded(tableData, item)" class="prikazi"
                                  (click)="gridtoggleExpandedRow(tableData, item)">
                                  Prikaži manje
                                </span>
                              </p>

                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Količina -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.quantityColumn as quantityColumn">
                            <ng-container *ngIf="$any(tableItem)[quantityColumn] as data">
                              <ng-container *ngIf="data.length > 0">
                                <label
                                  class="nowraptext font-semibold align-self-start text-primary">Količina:</label>&nbsp;
                                <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Vrsta sadržaja -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.contentTypeColumn as contentTypeColumn">
                            <ng-container *ngIf="$any(tableItem)[contentTypeColumn] as data">
                              <ng-container *ngIf="data.length > 0">
                                <label class="nowraptext font-semibold align-self-start text-primary">Vrsta
                                  sadržaja:</label>&nbsp;
                                <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Licenca -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.licenceColumn as licenceColumn">
                            <ng-container *ngIf="$any(tableItem)[licenceColumn] as data">
                              <ng-container *ngIf="data.length > 0">
                                <label
                                  class="nowraptext font-semibold align-self-start text-primary">Licenca:</label>&nbsp;
                                <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Razdoblje -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.timespanColumn as timespanColumn">
                            <ng-container *ngIf="$any(tableItem)[timespanColumn] as data">
                              <label
                                class="nowraptext font-semibold align-self-start text-primary">Razdoblje:</label>&nbsp;
                              <p class="mb-0 white-space-nowrap text-sm bg-primary text-white px-2 mr-2 mb-2">{{ data }}
                              </p>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Nadležni arhiv -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.archiveOwnerColumn as archiveOwnerColumn">
                            <ng-container *ngIf="$any(tableItem)[archiveOwnerColumn] as data">
                              <label class="nowraptext font-semibold align-self-start text-primary">Nadležni
                                arhiv:</label>&nbsp;
                              <p class="line-height-2 text-base">{{ data }}</p>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Link na mrežnu stranicu -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.webpageColumn as webpageColumn">
                            <ng-container *ngIf="$any(tableItem)[webpageColumn] as data">
                              <a class="mb-0 white-space-nowrap text-base mt-2 mb-2" [href]="data | linkPipe">{{ data
                                }}</a>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Status -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.statusColumn as statusColumn">
                            <ng-container *ngIf="$any(tableItem)[statusColumn] as data">
                              <label
                                class="nowraptext font-semibold align-self-start text-primary">Status:</label>&nbsp;
                              <p class="line-height-2 text-base">{{ data }}</p>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Povijest -->
                        <div class="agent-type flex align-items-center">
                          <ng-container *ngIf="tableMeta.historyColumn as historyColumn">
                            <ng-container *ngIf="$any(tableItem)[historyColumn] as data">
                              <label
                                class="nowraptext font-semibold align-self-start text-primary">Povijest:</label>&nbsp;
                              <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                            </ng-container>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="tableMeta.hasActions" class="table-col-actions">
                      <ntap-dynamic #rowActionBar [compId]="actionBarCompId" class="align-self-center"></ntap-dynamic>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </ng-template>
            <ng-template pTemplate="grid" ngFor let-item let-items>
              <div class="grid grid-nogutter">
                <ng-container *ngFor="let item of items; let first = first; let rowIndex = index"
                  class="col-12 sm:col-6 md:col-4 lg:col-3 xl:col-2">
                  <ng-container ntapListItemProvider #lid="ntapListItemProvider" [listIndex]="rowIndex" [item]="item"
                    *ngIf="tableData.tableItems[rowIndex] as tableItem">
                    <div class="grid-card m-3 border-1 surface-border" (click)="selectItem(item)"
                      [class.selected]="isSelected(item)" (mouseenter)="showOverlay($event, op, rowIndex)"
                      (mouseleave)="hideOverlay(op, rowIndex)">
                      <!-- Overlay Panel -->
                      <p-overlayPanel #op [styleClass]="'overlay-panel-' + rowIndex" [dismissable]="false"
                        [appendTo]="'body'">
                        <ng-template pTemplate>
                          <div class="overlay-content">
                            <!-- Sjedište -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.headquartersColumn as headquartersColumn">
                                <ng-container *ngIf="$any(tableItem)[headquartersColumn] as data">
                                  <label
                                    class="nowraptext font-semibold align-self-start text-primary">Sjedište:</label>&nbsp;
                                  <p class="mb-0 white-space-nowrap text-base px-2 mr-2 mb-2">{{ data }}</p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Radno vrijeme -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.hoursColumn as hoursColumn">
                                <ng-container *ngIf="$any(tableItem)[hoursColumn] as data">
                                  <label class="nowraptext font-semibold align-self-start text-primary">Radno
                                    vrijeme:</label>&nbsp;
                                  <p class="mb-0 white-space-nowrap text-base px-2 mr-2 mb-2">{{ data }}</p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Vrijeme nastanka -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.createdColumn as createdColumn">
                                <ng-container *ngIf="$any(tableItem)[createdColumn] as data">
                                  <label class="nowraptext font-semibold align-self-start text-primary">Vrijeme
                                    nastanka:</label>&nbsp;
                                  <p class="white-space-nowrap text-sm bg-primary text-white px-2 mr-2 mb-2">{{ data }}
                                  </p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Razina -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.levelColumn as levelColumn">
                                <label
                                  class="nowraptext font-semibold align-self-start text-primary">Razina:</label>&nbsp;
                                <p *ngIf="$any(tableItem)[levelColumn] as data"
                                  class="mb-0 white-space-nowrap text-sm bg-primary text-white px-2 mr-2 mb-2">{{ data
                                  }}</p>
                              </ng-container>
                            </div>

                            <!-- Posjednik / Nadlezni arhiv -->
                            <div class="agent-type flex align-items-center">
                              <ng-container
                                *ngIf="selectedLayoutOption.value === 'list' && tableMeta.ownerColumn as ownerColumn">
                                <ng-container *ngIf="$any(tableItem)[ownerColumn] as data">
                                  <label
                                    class="nowraptext font-semibold align-self-start text-primary">Posjednik:</label>&nbsp;
                                  <p class="line-height-2 text-base">{{ data }}</p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Nadređena jedinica gradiva -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.hierarhyLabelColumn as hierarhyLabelColumn">
                                <ng-container *ngIf="$any(tableItem)[hierarhyLabelColumn] as data">
                                  <label class="nowraptext font-semibold align-self-start text-primary">Nalazi se
                                    u:</label>&nbsp;
                                  <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Sadržaj -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.contentColumn as contentColumn">
                                <ng-container *ngIf="$any(tableItem)[contentColumn] as data">
                                  <p class="line-height-2 text-base">
                                    <span [ngClass]="{ 'custom-truncated-text': !isRowExpanded(tableData, item) }">
                                      {{ data }}
                                    </span>

                                    <span *ngIf="shouldShowToggle(data) && !isRowExpanded(tableData, item)"
                                      class="prikazi" (click)="gridtoggleExpandedRow(tableData, item)">
                                      Prikaži više
                                    </span>

                                    <span *ngIf="isRowExpanded(tableData, item)" class="prikazi"
                                      (click)="gridtoggleExpandedRow(tableData, item)">
                                      Prikaži manje
                                    </span>
                                  </p>

                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Količina -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.quantityColumn as quantityColumn">
                                <ng-container *ngIf="$any(tableItem)[quantityColumn] as data">
                                  <ng-container *ngIf="data.length > 0">
                                    <label
                                      class="nowraptext font-semibold align-self-start text-primary">Količina:</label>&nbsp;
                                    <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Vrsta sadržaja -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.contentTypeColumn as contentTypeColumn">
                                <ng-container *ngIf="$any(tableItem)[contentTypeColumn] as data">
                                  <ng-container *ngIf="data.length > 0">
                                    <label class="nowraptext font-semibold align-self-start text-primary">Vrsta
                                      sadržaja:</label>&nbsp;
                                    <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Licenca -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.licenceColumn as licenceColumn">
                                <ng-container *ngIf="$any(tableItem)[licenceColumn] as data">
                                  <ng-container *ngIf="data.length > 0">
                                    <label
                                      class="nowraptext font-semibold align-self-start text-primary">Licenca:</label>&nbsp;
                                    <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Razdoblje -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.timespanColumn as timespanColumn">
                                <ng-container *ngIf="$any(tableItem)[timespanColumn] as data">
                                  <label
                                    class="nowraptext font-semibold align-self-start text-primary">Razdoblje:</label>&nbsp;
                                  <p class="mb-0 white-space-nowrap text-sm bg-primary text-white px-2 mr-2 mb-2">{{
                                    data }}</p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Nadležni arhiv -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.archiveOwnerColumn as archiveOwnerColumn">
                                <ng-container *ngIf="$any(tableItem)[archiveOwnerColumn] as data">
                                  <label class="nowraptext font-semibold align-self-start text-primary">Nadležni
                                    arhiv:</label>&nbsp;
                                  <p class="line-height-2 text-base">{{ data }}</p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Link na mrežnu stranicu -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.webpageColumn as webpageColumn">
                                <ng-container *ngIf="$any(tableItem)[webpageColumn] as data">
                                  <a class="mb-0 white-space-nowrap text-base mt-2 mb-2" [href]="data | linkPipe">{{
                                    data }}</a>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Status -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.statusColumn as statusColumn">
                                <ng-container *ngIf="$any(tableItem)[statusColumn] as data">
                                  <label
                                    class="nowraptext font-semibold align-self-start text-primary">Status:</label>&nbsp;
                                  <p class="line-height-2 text-base">{{ data }}</p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Povijest -->
                            <div class="agent-type flex align-items-center">
                              <ng-container *ngIf="tableMeta.historyColumn as historyColumn">
                                <ng-container *ngIf="$any(tableItem)[historyColumn] as data">
                                  <label
                                    class="nowraptext font-semibold align-self-start text-primary">Povijest:</label>&nbsp;
                                  <p class="line-height-2 text-base truncated-text-2">{{ data }}</p>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </ng-template>
                      </p-overlayPanel>
                      <!-- Slika ili placeholder -->
                      <div class="grid-image-container">
                        <img *ngIf="item['$hasContent']" [src]="createUrl(item)" (error)="errorImg($event.target)"
                          class="grid-image" alt="Slika jedinice gradiva" />
                        <span *ngIf="!item['$hasContent']" class="placeholder-image">Nema slike</span>
                      </div>
                      <!-- Naslov -->
                      <div class="grid-title flex align-items-center">
                        <ng-container *ngIf="tableMeta.titleColumn as titleColumn">
                        @let isOpenItem =  $any(tableMeta)["isTitleOpenItemColumn"];
                        @if (isOpenItem) {
                            <a class="ui-cell-content" href="#"
                              (click)="openItem($event, lid); $event.stopPropagation();"
                              [attr.aria-label]="'Otvori jedinicu gradiva ' + $any(tableItem)[titleColumn]"><b>{{
                                $any(tableItem)[titleColumn] }}</b></a>
                        } @else {
                            <span>{{ $any(tableItem)[titleColumn] }}</span>
                        }
                        </ng-container>
                        <i *ngIf="item['en~jedinica_gradiva~locked']" class="pi pi-lock ml-2" pTooltip="Zaključano"
                          style="font-size: 1rem; color: var(--red-500);"></i>
                        <i *ngIf="item['en~jedinica_gradiva~locked'] === false" class="pi pi-lock-open ml-2" pTooltip="Otključano"
                          style="font-size: 1rem; color: var(--blue-500);"></i>
                      </div>
                      <!-- Arhivska oznaka -->
                      <div class="grid-label">
                        <ng-container *ngIf="$any(tableItem)[$any(tableMeta.labelColumn)] as data">
                          <p class="mb-0 white-space-nowrap text-sm bg-primary text-white px-2">{{ data }}</p>
                        </ng-container>
                      </div>
                      <!-- Gumb Uredi -->
                      <ng-container *ngIf="tableMeta.hasActions">
                        <ntap-dynamic #rowActionBar [compId]="actionBarCompId" class="grid-actions"></ntap-dynamic>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </ng-template>

            <ng-template pTemplate="paginatorleft" let-state>
              {{ state.first + 1 }}-{{ (state.first + state.rows > state.totalRecords) ? state.totalRecords :
              state.first
              +
              state.rows }}
              od {{ state.totalRecords }}
            </ng-template>

            <ng-template pTemplate="empty">
              Nema podataka.
            </ng-template>

          </p-dataView>
        </ng-container>

      </p-card>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #loadingView>
  <p-progressSpinner></p-progressSpinner>
</ng-template>